import { useCallback } from "react";

import { Checkbox } from "@otta/search/components/Input/Checkbox";
import { Spacing, Text } from "@otta/design";
import { LabelledLocation } from "@otta/search/constants/locations";
import { partition } from "@otta/search/utils/collections";
import { Location as LocationType } from "@otta/search/schema";

interface LocationCheckboxProps {
  label: string;
  checked: boolean;
  onChange: (preference: string, checked: boolean) => void;
  value: string;
}

interface LocationCheckboxListProps {
  locations: readonly LabelledLocation[];
  value: readonly LocationType[];
  handleChange: (preference: string, checked: boolean) => void;
}

export function LocationCheckbox({
  label,
  checked,
  value,
  onChange,
}: LocationCheckboxProps): React.ReactElement {
  const handleChange = useCallback<React.ChangeEventHandler<HTMLInputElement>>(
    e => onChange(value, e.target.checked),
    [onChange, value]
  );

  return <Checkbox label={label} onChange={handleChange} checked={checked} />;
}

function ComingSoon() {
  return (
    <div
      style={{
        padding: 24,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 8,
      }}
    >
      <Text bold>Coming soon</Text>
      <Text>
        You can now select from 10 new cities in the UK - some jobs are live
        now, and a lot more are coming soon!
      </Text>
    </div>
  );
}

export function LocationCheckboxList({
  locations,
  value,
  handleChange,
}: LocationCheckboxListProps) {
  const [others, london] = partition(locations)(
    loc => loc.location === LocationType.London
  );
  const londonLabelledLocation = london?.[0];

  return (
    <Spacing size={-4}>
      {londonLabelledLocation && (
        <LocationCheckbox
          key={londonLabelledLocation.location}
          label={londonLabelledLocation.label}
          onChange={handleChange}
          checked={value.some(pref => pref === londonLabelledLocation.location)}
          value={londonLabelledLocation.location}
        />
      )}
      {londonLabelledLocation && <ComingSoon />}
      {others.map(({ location, label }) => (
        <LocationCheckbox
          key={location}
          label={label}
          onChange={handleChange}
          checked={value.some(pref => pref === location)}
          value={location}
        />
      ))}
    </Spacing>
  );
}
